import React from 'react';

function Cipher() {

    return (
        <div className='cipher_container'>
        
            <div className='Info'>
                <h2>INFORMATION</h2>
                {/* <h2>TEST 20 lines</h2> */}
                    <h3>I was inspired by The Beale Cipher and decided to make my own treasure hunt. Enjoy and happy hunting!
                    </h3>  
            </div>


            <div className='cipher'>

                <h2>LOCATION CIPHER</h2>

                <h3>
                7 112 240 258 126 277 50 40 98 13 154 146 144

                74 178 156 32 491 8  4 74 70 361 41  14 37 32

                63 154 61 130 122 126 56 87 27 491 463 462 75 62

                186 488 11 2 9 36 379 96 360 488 383 482 154 13 

                65 179 435  429 19 121 146 502 505 115 498 508 212 

                28 41 488 481 319 300 363 70 186 96 12 98 507 37

                440 22 291 281 297 472 126 33 54 126 70 67  7 179

                154 156 145 170 33 258 112 350 7 40 28 55 144 126

                59 76 24 224 98 130 38 501 63 507 150 151  126 82 29

                84 154 115 127 114 70 126 70 69 6 48 130 388 23 378 379

                67 77 2 491 115 82 98 429 130 323 335 197 29 82 5

                1 186 8 4 17 28 95 168 196 248 280 484 277 510 13

                154 488 115 63 70 19 12 374 154 384 404 491 115 87

                79 24 488 96 63 193 33 491 12 118 34 66 7 29 240 56

                126 491 488 54 97 130 499 79 126 500 15 507 11 132

                443 87 341 102 6 22 506 7 8 58 328 34 177 63 259 167
                </h3>
            
            </div>

         

        </div>
    
    )
}
export default Cipher;
